export default "__VITE_ASSET__D2XZkE0c__"